"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useCarouselWidth = exports.BREAKPOINT_WIDTH_MAP = void 0;
var _mui = require("@ori-ui/mui");
var _react = require("react");
var _constants = require("./constants");
const BREAKPOINT_WIDTH_MAP = exports.BREAKPOINT_WIDTH_MAP = {
    editorial: {
        sm: _constants.CAROUSEL_MOBILE_WIDTH,
        md: _constants.CAROUSEL_TABLET_WIDTH,
        lg: _constants.CAROUSEL_BIG_TABLET_WIDTH,
        default: _constants.CAROUSEL_DESKTOP_WIDTH
    },
    myPages: {
        sm: _constants.CAROUSEL_MYPAGES_MOBILE_WIDTH,
        md: _constants.CAROUSEL_MYPAGES_TABLET_WIDTH,
        lg: _constants.CAROUSEL_MYPAGES_BIG_TABLET_WIDTH,
        default: _constants.CAROUSEL_MYPAGES_WIDTH
    }
};
const useCarouselWidth = (renderOnMyPages)=>{
    const isSm = (0, _mui.useMediaQuery)((theme)=>theme.breakpoints.down('sm'));
    const isMd = (0, _mui.useMediaQuery)((theme)=>theme.breakpoints.down('md'));
    const isLg = (0, _mui.useMediaQuery)((theme)=>theme.breakpoints.down('lg'));
    return (0, _react.useMemo)(()=>{
        const mode = renderOnMyPages ? 'myPages' : 'editorial';
        if (isSm) {
            return BREAKPOINT_WIDTH_MAP[mode].sm;
        }
        if (isMd) {
            return BREAKPOINT_WIDTH_MAP[mode].md;
        }
        if (isLg) {
            return BREAKPOINT_WIDTH_MAP[mode].lg;
        }
        return BREAKPOINT_WIDTH_MAP[mode].default;
    }, [
        isSm,
        isMd,
        isLg,
        renderOnMyPages
    ]);
};
exports.useCarouselWidth = useCarouselWidth;
